import { API_ENDPOINTS } from "./Constants";
import { apiFetch } from "./apiHelper";

export async function addAuthor(authorData) {
    const response = await apiFetch(API_ENDPOINTS.AUTHOR, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(authorData),
    });

    if (!response.ok) {
        const data = await response.json();
        throw new Error(data.message || "Greška prilikom dodavanja autora");
    }

    return response.json();
}

export async function getAllAuthors() {
    const response = await apiFetch(API_ENDPOINTS.AUTHOR);

    if (!response.ok) {
        const data = await response.json();
        throw new Error(data.message || "Greška prilikom dohvaćanja autora");
    }

    return response.json();
}

export async function getAuthorById(id) {
    const response = await apiFetch(`${API_ENDPOINTS.AUTHOR}/${id}`);

    if (!response.ok) {
        const data = await response.json();
        throw new Error(data.message || `Greška prilikom dohvaćanja autora ID=${id}`);
    }

    return response.json();
}

export async function updateAuthor(id, authorData) {
    const response = await apiFetch(`${API_ENDPOINTS.AUTHOR}/${id}`, {
        method: "PUT",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(authorData),
    });

    if (!response.ok) {
        const data = await response.json();
        throw new Error(data.message || `Greška prilikom ažuriranja autora ID=${id}`);
    }

    return response.json();
}

export async function deleteAuthor(id) {
    const response = await apiFetch(`${API_ENDPOINTS.AUTHOR}/${id}`, {
        method: "DELETE",
        credentials: "include",
    });

    if (!response.ok) {
        const data = await response.json();
        throw new Error(data.message || `Greška prilikom brisanja autora ID=${id}`);
    }

    return true;
}

export async function searchAuthors(term) {
    const response = await apiFetch(
        `${API_ENDPOINTS.AUTHOR}/search?term=${encodeURIComponent(term)}`
    );

    if (!response.ok) {
        const data = await response.json();
        throw new Error(
            data.message || `Greška prilikom pretrage autora po terminu: ${term}`
        );
    }

    return response.json();
}
